/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import AppTestimonial from '@landing_pages/sadhguru-app/AppTestimonial';
import Banner from '@landing_pages/sadhguru-app/Banner';
import DownloadTheApp from '@landing_pages/sadhguru-app/DownloadTheApp';
import Language from '@landing_pages/sadhguru-app/Language';
import SelfTransformation from '@landing_pages/sadhguru-app/SelfTransformation';
import Video from '@landing_pages/sadhguru-app/Video';
import ZigzagCards from '@landing_pages/sadhguru-app/ZigzagCards';
import { AuthContext } from '@store/auth-context';
import AdBanner from '@components/Card/ImageBannerAd';

/* Services */
import {
    getLocale
} from '@components/Utility/Shared/SharedService';
import {
    fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/othersService';

/* Styles */

/**
 *
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Search Landing Page Data
 */
const SadhguruRadio = ({ region, language, pageData }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);

  return (
    <Box float="left" w="100%">
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData?.breadcrumbs}
        alsoin={pageData?.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />

      <Box as="section">
        {pageData?.body && pageData?.body?.length
          ? pageData?.body?.map((section, i) => {
              if (section?.sectionId === 'sadhguru-app-banner') {
                return (
                  <Banner
                    sectionContent={section?.sectionContent}
                    region={region}
                    lang={language}
                  />
                );
              } else if (section.sectionId === 'sadhguru-ad-banner') {
                return (
                  <AdBanner
                    sectionContent={section.sectionContent[0]}
                    region={region}
                    lang={language}
                  />
                );
              } else if (section.sectionId === 'download-the-app') {
                return (
                  <DownloadTheApp
                    sectionContent={section.sectionContent}
                    region={region}
                    lang={language}
                  />
                );
              } else if (section.sectionId === 'zigzag-cards') {
                return (
                  <ZigzagCards
                    sectionContent={section.sectionContent}
                    region={region}
                    lang={language}
                  />
                );
              } else if (section.sectionId === 'available-languages') {
                return (
                  <Language
                    sectionContent={section.sectionContent}
                    region={region}
                    lang={language}
                  />
                );
              } else if (section.sectionId === 'sadhguru-app-video') {
                return (
                  <Video
                    sectionContent={section.sectionContent}
                    region={region}
                    lang={language}
                  />
                );
              } else if (section.sectionId === 'self-transformation') {
                return (
                  <SelfTransformation
                    sectionContent={section.sectionContent}
                    region={region}
                    lang={language}
                  />
                );
              } else if (section.sectionId === 'testimonials') {
                return (
                  <AppTestimonial
                    sectionContent={pageData}
                    region={region}
                    lang={language}
                  />
                );
              }
            })
          : null}
      </Box>

      {/* <Box as="section"> */}
      {/* -------------------==============================-------------- */}
      {/* <Banner sectionContent={pageData} region={region} lang={language} /> */}
      {/* <Download sectionContent={pageData} region={region} lang={language} /> */}
      {/* <Cards sectionContent={pageData} region={region} lang={language} /> */}
      {/* <Language sectionContent={pageData} region={region} lang={language} /> */}
      {/* <Video sectionContent={pageData} region={region} lang={language} />
        <AppSection sectionContent={pageData} region={region} lang={language} />
        <AppTestimonial
          sectionContent={pageData}
          region={region}
          lang={language}
        /> */}
      {/* </Box> */}
    </Box>
  );
};

export const getStaticPaths = async () => {
  const sadhguruAppPaths = config.USE_LOCAL_URL
    ? [`/in/en/sadhguru-app`]
    : await getLandingPaths('lvl0', '/sadhguru-app');
  return {
    paths: sadhguruAppPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(region, language, `sadhguru-app`,
    { preview, data: previewData });

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,      
      isPreview: preview ? true : false
    }
  };
};

export default SadhguruRadio;
